export const manifest = {
  screens: {
    scr_ylpx3w: { name: "Overview – In evidenza", route: "/costs", state: {"activeTab":"In evidenza"}, position: {"x":160,"y":220} },
    scr_pwngg7: { name: "Overview – Per te", route: "/costs", state: {"activeTab":"Per te"}, position: {"x":1560,"y":220} },
    scr_gje7vn: { name: "Overview – Tutti i servizi", route: "/costs", state: {"activeTab":"Tutti i servizi"}, position: {"x":2960,"y":220} },
    scr_50u20c: { name: "Cost Management – Panoramica", route: "/cost-management", state: {"activeTab":"Panoramica"}, position: {"x":160,"y":2200} },
    scr_k45xba: { name: "Cost Management – Per Servizio", route: "/cost-management", state: {"activeTab":"Per Servizio"}, position: {"x":1560,"y":2200} },
    scr_nzbm1h: { name: "Cost Management – Per Provider", route: "/cost-management", state: {"activeTab":"Per Provider"}, position: {"x":2960,"y":2200} },
    scr_71mjx2: { name: "Cost Management – Budget", route: "/cost-management", state: {"activeTab":"Budget"}, position: {"x":4360,"y":2200} },
    scr_yrt5qr: { name: "AI Act", route: "/compliance/ai-act", position: {"x":160,"y":8140} },
    scr_5tm3t9: { name: "GDPR – Monitoraggio", route: "/compliance/gdpr", state: {"activeTab":"Monitoraggio"}, position: {"x":160,"y":6160} },
    scr_dykee5: { name: "GDPR – Scansione Repository", route: "/compliance/gdpr", state: {"activeTab":"Scansione Repository"}, position: {"x":1560,"y":6160} },
    scr_20a0ae: { name: "GDPR – DPO & Responsabili", route: "/compliance/gdpr", state: {"activeTab":"DPO & Responsabili"}, position: {"x":2960,"y":6160} },
    scr_k7blo0: { name: "GDPR – Dati Sensibili", route: "/compliance/gdpr", state: {"activeTab":"Dati Sensibili"}, position: {"x":4360,"y":6160} },
    scr_yt8d61: { name: "Audit Trail", route: "/compliance/audit", position: {"x":1560,"y":8140} },
    scr_8buso0: { name: "GreenOps – Panoramica", route: "/greenops", state: {"activeTab":"Panoramica"}, position: {"x":160,"y":4180} },
    scr_emwf9t: { name: "GreenOps – Per Servizio", route: "/greenops", state: {"activeTab":"Per Servizio"}, position: {"x":1560,"y":4180} },
    scr_ypbjah: { name: "GreenOps – Per Provider", route: "/greenops", state: {"activeTab":"Per Provider"}, position: {"x":2960,"y":4180} },
    scr_csqz1j: { name: "GreenOps – Code Scan", route: "/greenops", state: {"activeTab":"Code Scan"}, position: {"x":4360,"y":4180} },
    scr_vg54k7: { name: "AI Map", route: "/canvas", position: {"x":160,"y":10120} },
    scr_ejt94y: { name: "Report", route: "/reports", position: {"x":1560,"y":10120} },
    scr_zr3of3: { name: "Provider", route: "/providers", position: {"x":160,"y":12100} },
    scr_e1hrsi: { name: "Provider Detail – Produzione", route: "/providers/p1", state: {"activeEnv":"Produzione"}, position: {"x":1560,"y":12100} },
    scr_hqqy2m: { name: "Provider Detail – Staging", route: "/providers/p1", state: {"activeEnv":"Staging"}, position: {"x":2960,"y":12100} },
    scr_z1agw8: { name: "Provider Detail – Development", route: "/providers/p1", state: {"activeEnv":"Development"}, position: {"x":4360,"y":12100} },
    scr_s0jynb: { name: "Fornitori", route: "/users", position: {"x":160,"y":14080} },
    scr_nv8lbl: { name: "Servizio – Overview", route: "/servizio/s1", state: {"activeTab":"overview"}, position: {"x":160,"y":16060} },
    scr_pyx8nx: { name: "Servizio – Canali", route: "/servizio/s1", state: {"activeTab":"canali"}, position: {"x":1560,"y":16060} },
    scr_kv3565: { name: "Servizio – Knowledge", route: "/servizio/s1", state: {"activeTab":"knowledge"}, position: {"x":2960,"y":16060} },
    scr_bpmlm9: { name: "Servizio – Log", route: "/servizio/s1", state: {"activeTab":"log"}, position: {"x":4360,"y":16060} },
    scr_bvry15: { name: "Impostazioni", route: "/impostazioni", position: {"x":160,"y":18040} },
  },
  sections: {
    sec_3nij5j: { name: "Overview", x: 0, y: 0, width: 4320, height: 1180 },
    sec_1wifji: { name: "Cost Management", x: 0, y: 1980, width: 5720, height: 1180 },
    sec_p5syed: { name: "GreenOps", x: 0, y: 3960, width: 5720, height: 1180 },
    sec_k1uk7p: { name: "Compliance – GDPR", x: 0, y: 5940, width: 5720, height: 1180 },
    sec_sk93i5: { name: "Compliance – Other", x: 0, y: 7920, width: 2920, height: 1180 },
    sec_ug68l3: { name: "AI Map & Reports", x: 0, y: 9900, width: 2920, height: 1180 },
    sec_di5lg5: { name: "Providers", x: 0, y: 11880, width: 5720, height: 1180 },
    sec_yycdif: { name: "Users", x: 0, y: 13860, width: 1520, height: 1180 },
    sec_g9sqga: { name: "Servizio Management", x: 0, y: 15840, width: 5720, height: 1180 },
    sec_lw7eqi: { name: "Settings", x: 0, y: 17820, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_3nij5j", children: [
      { kind: "screen", id: "scr_ylpx3w" },
      { kind: "screen", id: "scr_pwngg7" },
      { kind: "screen", id: "scr_gje7vn" },
    ] },
    { kind: "section", id: "sec_1wifji", children: [
      { kind: "screen", id: "scr_50u20c" },
      { kind: "screen", id: "scr_k45xba" },
      { kind: "screen", id: "scr_nzbm1h" },
      { kind: "screen", id: "scr_71mjx2" },
    ] },
    { kind: "section", id: "sec_p5syed", children: [
      { kind: "screen", id: "scr_8buso0" },
      { kind: "screen", id: "scr_emwf9t" },
      { kind: "screen", id: "scr_ypbjah" },
      { kind: "screen", id: "scr_csqz1j" },
    ] },
    { kind: "section", id: "sec_k1uk7p", children: [
      { kind: "screen", id: "scr_5tm3t9" },
      { kind: "screen", id: "scr_dykee5" },
      { kind: "screen", id: "scr_20a0ae" },
      { kind: "screen", id: "scr_k7blo0" },
    ] },
    { kind: "section", id: "sec_sk93i5", children: [
      { kind: "screen", id: "scr_yrt5qr" },
      { kind: "screen", id: "scr_yt8d61" },
    ] },
    { kind: "section", id: "sec_ug68l3", children: [
      { kind: "screen", id: "scr_vg54k7" },
      { kind: "screen", id: "scr_ejt94y" },
    ] },
    { kind: "section", id: "sec_di5lg5", children: [
      { kind: "screen", id: "scr_zr3of3" },
      { kind: "screen", id: "scr_e1hrsi" },
      { kind: "screen", id: "scr_hqqy2m" },
      { kind: "screen", id: "scr_z1agw8" },
    ] },
    { kind: "section", id: "sec_yycdif", children: [
      { kind: "screen", id: "scr_s0jynb" },
    ] },
    { kind: "section", id: "sec_g9sqga", children: [
      { kind: "screen", id: "scr_nv8lbl" },
      { kind: "screen", id: "scr_pyx8nx" },
      { kind: "screen", id: "scr_kv3565" },
      { kind: "screen", id: "scr_bpmlm9" },
    ] },
    { kind: "section", id: "sec_lw7eqi", children: [
      { kind: "screen", id: "scr_bvry15" },
    ] },
  ],
}
